import type { UseElectricalProjectFileDownloadOptions } from '@/hooks/use-electrical-project-file-download';

import { useElectricalProjectFileDownload } from '@/hooks/use-electrical-project-file-download';
import { cn } from '@/lib/utils';

import type { ImageExpandableProps } from './image';

import { Image } from './image';

type ElectricalProjectImageProps = UseElectricalProjectFileDownloadOptions & ImageExpandableProps & {
    alt?: string;
    className?: string;
};

export function ElectricalProjectImage(props: ElectricalProjectImageProps) {
    const { alt, className } = props;
    const download = useElectricalProjectFileDownload(props);

    if (props.expandable) {
        return (
            <Image
                file={download.file}
                isLoading={download.isLoading}
                disabled={!download.file || download.isError}
                className={cn('w-24 h-24 rounded-md object-contain ', className)}
                alt={alt}
                expandable
                ref={props.ref}
            />
        );
    }

    return (
        <Image
            file={download.file}
            isLoading={download.isLoading}
            disabled={!download.file || download.isError}
            className={cn('w-24 h-24 rounded-md object-contain', className)}
            alt={alt}
            expandable={false}
            ref={props.ref}
        />
    );
}
